import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_BASE = process.env.REACT_APP_ROOM_NATE_API;
const API_VERSION = process.env.REACT_APP_ROOM_NATE_VERSION;
const baseUrl = `${(API_BASE ?? "").replace(/\/$/, "")}/${API_VERSION ?? ""}`;

const createRequest = (url) => ({ url });

const createPostRequest = (url, data) => ({
  method: "POST",
  url,
  body: data,
});

export const constantApis = createApi({
  reducerPath: "constantApis",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const states = getState();
      if (states?.roomNateSlice.currentToken) {
        headers.set(
          "Authorization",
          `Bearer ${
            states.roomNateSlice.currentToken
              ? states.roomNateSlice.currentToken.replace(/["]/g, "")
              : ""
          }`
        );
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllZone: builder.query({
      query: () => createRequest(`/items/zones`),
    }),
    getAllShapes: builder.query({
      query: () => createRequest(`/items/shapes`),
    }),
    getAllConnectionPointsOptions: builder.query({
      query: () => createRequest(`/items/connection-points-options`),
    }),
    getAllConnectionPoints: builder.query({
      query: () => createRequest(`/items/connection-points`),
    }),
    getItemsByZone: builder.query({
      query: (zones) => {
        const updatedZones = [...zones];
        const hasComingAndGoing = updatedZones.some(
          (zone) => zone.value === "comingandgoing"
        );
        if (hasComingAndGoing) {
          updatedZones.push({ value: "sleeping", capacity: 1 });
        }
        const url = `/items/itembyzones?zones=${updatedZones
          .map((zone) => zone.value)
          .join(",")}`;
        return createRequest(url);
      },
    }),
    getAllItemsBySupplementary: builder.query({
      query: (zones) => {
        let url = "/items/itembyzones?type=2";
        

        if (zones && zones?.length > 0) {
          const zoneValues = zones.map((z) => z.value).join(",");
          url += `&zones=${zoneValues}`;
        }

        return createRequest(url);
      },
    }),
    getItemsBySupplementary: builder.query({
      query: (zones) => {
        const url = `/items/itembyzones?zones=${zones}&type=2`;
        return createRequest(url);
      },
    }),
    getAllVibes: builder.query({
      query: () => createRequest(`/vibe/parent`),
    }),
    processVibes: builder.mutation({
      query: (data) => createPostRequest("/vibe/process-vibes", data),
    }),
    moodboardVibes: builder.mutation({
      query: (data) => createPostRequest("/vibe/moodboard", data),
    }),
    getIframesByParams: builder.query({
      query: ({ items, style }) => {
        const itemIds = items && Array.isArray(items) ? items.map((zone) => zone).join(",") : "";
        const url = `/amazon?itemIds=${itemIds}${
          style ? `&styleIds=${style}` : ""
        }`;
        return createRequest(url);
      },
    }),
    getAllParentStyles: builder.query({
      query: () => createRequest(`/vibe/parentstyles/`),
    }),
    parentStylesImages: builder.mutation({
      query: (data) => createPostRequest("/vibe/parentstyleimages/", data),
    }),
  }),
});

export const {
  useGetAllZoneQuery,
  useGetAllShapesQuery,
  useGetAllConnectionPointsQuery,
  useGetAllConnectionPointsOptionsQuery,
  useGetItemsByZoneQuery,
  useGetAllVibesQuery,
  useProcessVibesMutation,
  useMoodboardVibesMutation,
  useGetIframesByParamsQuery,
  useGetAllParentStylesQuery,
  useParentStylesImagesMutation,
  useGetItemsBySupplementaryQuery,
  useGetAllItemsBySupplementaryQuery
} = constantApis;
